import { createAction } from "@reduxjs/toolkit"

import type {
  MissingPermissions,
  RequestBlockedInDemo,
} from "@/base/check-permissions"
import type { FieldActionName } from "./farm-fields.reducer"
import type { StatusMapFeatureName } from "./status-map.reducer"

// TODO: Get rid of these
export const clickCancel = createAction("CLICK_CANCEL")

export const denyPermission = createAction<
  MissingPermissions | RequestBlockedInDemo
>("DENY PERMISSION")

export const clearSelectedTrigger = createAction("CLEAR_SELECTED_TRIGGER")

export const setActiveFeature = createAction<
  | StatusMapFeatureName
  | { value: StatusMapFeatureName | undefined }
  | undefined
>("SET_ACTIVE_FEATURE")

export const setFieldActionsName = createAction<
  FieldActionName | { value: FieldActionName | undefined } | undefined
>("fields/setFieldActionsName")
